import React from "react";
import PT from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { FbIcon } from "../../atoms/icons/fb-icon";
import { GplusIcon } from "../../atoms/icons/gplus-icon";
import { TwitterIcon } from "../../atoms/icons/twitter-icon";
import { YoutubeIcon } from "../../atoms/icons/youtube-icon";
import { LinkedinIcon } from "../../atoms/icons/linkedin-icon";
import { InstagramIcon } from "../../atoms/icons/instagram-icon";
import assetify from "@quintype/framework/assetify";
import podcastIcon from "../../../../assets/images/podcast-solid.svg";
import telegramIcon from "../../../../assets/images/telegram.svg";
import linkedinIcon from "../../../../assets/images/linkedin.svg";
import spotifyIcon from "../../../../assets/images/spotify.svg";
import castBoxIcon from "../../../../assets/images/castbox.svg";
import "./social-icons.m.css";

export function SocialIconsBase({ socialLinks ={}, showPodcast=false,  showTelegram=false, showLinkedin=false, showSpotify=false, showCastBox=false, publisher }) {
  return (
    <ul styleName="social-icons" className="social-icons">
      {socialLinks["facebook-url"] && (
        <li styleName="social-icon">
          <a href={socialLinks["facebook-url"]} target="_blank" styleName="link">
            <FbIcon />
          </a>
        </li>
      )}
      {socialLinks["gplus-url"] && (
        <li styleName="social-icon">
          <a href={socialLinks["gplus-url"]} styleName="link" target="_blank">
            <GplusIcon />
          </a>
        </li>
      )}
      {socialLinks["twitter-url"] && (
        <li styleName="social-icon">
          <a href={socialLinks["twitter-url"]} styleName="link" target="_blank">
            <TwitterIcon />
          </a>
        </li>
      )}
      {socialLinks["linkedin-url"] && (
        <li styleName="social-icon">
          <a href={socialLinks["linkedin-url"]} styleName="link" target="_blank">
            <LinkedinIcon />
          </a>
        </li>
      )}
      {socialLinks["youtube-url"] && (
        <li styleName="social-icon">
          <a href={socialLinks["youtube-url"]} styleName="link" target="_blank">
            <YoutubeIcon />
          </a>
        </li>
      )}
      {socialLinks["instagram-url"] && (
        <li styleName="social-icon">
          <a href={socialLinks["instagram-url"]} styleName="link" target="_blank">
            <InstagramIcon width={18} height={18} />
          </a>
        </li>
         )}
         {showPodcast && (
           <li styleName="social-icon">
             <a href={publisher["applepodcastUrl"]} styleName="link" target="_blank">
             <img  src={assetify(podcastIcon)} alt="apple podcast" />
             </a>
           </li>
      )}
        {showTelegram && (
           <li styleName="social-icon">
             <a href={publisher["telegramUrl"]} styleName="link" target="_blank">
             <img  src={assetify(telegramIcon)} alt="telegram" />
             </a>
           </li>
      )}
      {showLinkedin && (
           <li styleName="social-icon">
             <a href={publisher["linkedinUrl"]} styleName="link" target="_blank">
             <img  src={assetify(linkedinIcon)} alt="linkedin" />
             </a>
           </li>
      )}
      {showSpotify && (
           <li styleName="social-icon">
             <a href={publisher["spotifyUrl"]} styleName="link" target="_blank">
             <img  src={assetify(spotifyIcon)} alt="spotify" />
             </a>
           </li>
      )}
      {showCastBox && (
           <li styleName="social-icon">
             <a href={publisher["castboxUrl"]} styleName="link" target="_blank">
             <img  src={assetify(castBoxIcon)} alt="linkedin" />
             </a>
           </li>
      )}
    </ul>
  );
}

SocialIconsBase.propTypes = {
  socialLinks: PT.object
};


function mapStateToProps(state) {
  return {
    publisher: get(state, ["qt", "config", "publisher", "publisher"], [])
  }
}
   

export const SocialIcons = connect(mapStateToProps)(SocialIconsBase);
